import { jsx } from "react/jsx-runtime";
import { noop } from "../../../utils/index.js";
import { Button } from "../../Button/Button.js";
import { IconButton } from "../../IconButton/index.js";
import { useResponsive } from "../../ResponsiveWrapper/index.js";
import { Tooltip } from "../../Tooltip/Tooltip.js";
function VoiceButton({ onVoiceClickHandler = noop, voiceButtonType = 'textButton', slots = {
    iconSlot: ''
}, tooltipProps, disabled, glass = false }) {
    const { md } = useResponsive();
    const showVoiceTextButton = 'textButton' === voiceButtonType;
    const buttonType = glass ? 'radialSecondary' : 'secondary';
    const size = md ? 'md' : 'sm';
    const sharedProps = {
        onClick: onVoiceClickHandler,
        'aria-label': 'Realtime Voice Button',
        type: buttonType,
        size,
        id: 'realtime-voice-button',
        disabled
    };
    const Node = showVoiceTextButton ? /*#__PURE__*/ jsx(Button, {
        ...sharedProps,
        iconLeft: "Waveform",
        slots: {
            iconSlot: slots?.iconSlot
        },
        children: "Voice"
    }) : /*#__PURE__*/ jsx(IconButton, {
        ...sharedProps,
        slots: {
            iconSlot: slots?.iconSlot
        },
        iconName: "Waveform"
    });
    if (tooltipProps?.children) {
        const { className: toolTipClass, ...restTooltipProps } = tooltipProps;
        return /*#__PURE__*/ jsx(Tooltip, {
            ...restTooltipProps,
            emphasis: true,
            className: toolTipClass,
            triggerNode: Node
        });
    }
    return Node;
}
export { VoiceButton };
